import {
  OnFetchLastViewedProductsStarted,
  OnLastViewedProductsFetchError,
  OnLastViewProductsFetched
} from './lastViewedProducts.types'

export const FETCH_LAST_VIEWED_PRODUCTS_ERROR = 'FETCH_LAST_VIEWED_PRODUCTS_ERROR'
export const LAST_VIEWED_PRODUCTS_FETCHED = 'LAST_VIEWED_PRODUCTS_FETCHED'
export const ON_FETCH_LAST_VIEWED_PRODUCTS_STARTED = 'ON_FETCH_LAST_VIEWED_PRODUCTS_STARTED'

export const onLastViewedProductsFetchError: OnLastViewedProductsFetchError = error => ({
  payload: { error },
  type: FETCH_LAST_VIEWED_PRODUCTS_ERROR
})

export const onLastViewProductsFetched: OnLastViewProductsFetched = products => ({
  payload: products,
  type: LAST_VIEWED_PRODUCTS_FETCHED
})

export const onFetchLastViewedProductsStarted: OnFetchLastViewedProductsStarted = () => ({
  type: ON_FETCH_LAST_VIEWED_PRODUCTS_STARTED
})
